export const Base_Url = 'https://big.api.wowinfosolutions.com/api';

export const generatePdf_Url = `https://node-js-multipurpose-api.vercel.app`;